import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Lang from "../../userPreferences/staticWords";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import Button from "../sharedComponents/buttons/button";
import { useDispatch, useSelector } from "react-redux";
import {
  addAgendaAPI,
  updateAgendaAPI,
} from "../../API/store/actions/agendaAndLinks";
import { paths } from "../../paths/paths";
import {
  getCommunityTaskForm,
  getTaskSearch,
} from "../../API/store/actions/tasks";
import Select from "react-select";
import { resolver } from "../../API/middlewares/resolveRequests";
import MembersList from "../../algorithms/listsAlogrithms";

const AgendaForm = (props) => {
  const { show, setShow, isEdit, onSuccess } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [title, setTitle] = useState("");
  const getToday = () => new Date();
  const [recordDate, setRecordDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [files, setFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [taskFormData, setTaskFormData] = useState(null);
  const [searchDropdowns, setSearchDrobdowns] = useState({});
  const [communityId, setCommunityId] = useState(0);
  const [planned, setPlanned] = useState(true);
  const [agendaMembers, setAgendaMembers] = useState([]);
  const [attend, setAttend] = useState(true);

  const dispatch = useDispatch();

  const selectedAgenda = useSelector((state) => state.agenda.selectedAgenda);
  const user = useSelector((state) => state.login.userData);
  const token = useSelector((state) => state.login.userToken);
  const community = 0;
  const resetForm = () => {
    setTitle("");
    setRecordDate(new Date());
    setEndDate(null);
    setFiles([]);
    setErrors({});
    setCommunityId(0);
    setPlanned(false); // or true if this is your default
    setAttend(false);
    setAgendaMembers([]);
    setIsSubmitting(false);
  };
  useEffect(() => {
    if (!show) return;

    if (isEdit && selectedAgenda) {
      setTitle(selectedAgenda.data.title || "");
      setRecordDate(new Date(selectedAgenda.data.registerDate));
      setEndDate(
        selectedAgenda.data.endDate
          ? new Date(selectedAgenda.data.endDate)
          : null,
      );
      setPlanned(selectedAgenda.data.planned);
      setCommunityId(selectedAgenda.data.communityId);
      setAttend(selectedAgenda.data?.attend);
      setAgendaMembers(selectedAgenda.data.agendaMembers?.map((x) => x) || []);
      setFiles([]);
    }

    if (!isEdit) {
      setTitle("");
      setRecordDate(new Date());
      setEndDate(null);
      setPlanned(false);
      setAttend(false);
      setCommunityId(0);
      setAgendaMembers([]);
      setFiles([]);
    }
  }, [show, isEdit, selectedAgenda]);
  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);
  let membersList = [];
  let communitiesList = [];

  if (searchDropdowns?.data?.members) {
    membersList = searchDropdowns?.data?.members;
  }
  if (searchDropdowns?.data?.communities) {
    communitiesList = searchDropdowns?.data?.communities.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }

  useEffect(() => {
    resolver(getTaskSearch, setSearchDrobdowns, community, token);
  }, [community]);
  const handleFilesChange = (e) => {
    setFiles(Array.from(e.target.files));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!title.trim()) {
      validationErrors.title = Lang.required;
    }

    if (!recordDate) {
      validationErrors.recordDate = Lang.required;
    }
    if (!endDate) {
      validationErrors.endDate = Lang.required;
    }
    if (endDate && recordDate && endDate < recordDate) {
      validationErrors.endDate = "تاريخ النهاية يجب أن يكون بعد تاريخ البداية";
    }
    if (!isEdit && files.length === 0) {
      validationErrors.file = Lang.required;
    }
    if (!communityId) {
      validationErrors.communityId = Lang.required;
    }
    if (agendaMembers.length === 0) {
      validationErrors.agendaMembers = Lang.required;
    }
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("Title", title);
    formData.append(
      "RegisterDate",
      recordDate instanceof Date ? recordDate.toISOString() : recordDate,
    );
    formData.append(
      "EndDate",
      endDate instanceof Date ? endDate.toISOString() : endDate,
    );
    formData.append("Active", true);

    formData.append("CommunityId", communityId);

    agendaMembers.forEach((id) => {
      formData.append("AgendaMembers", id);
    });

    files.forEach((file) => {
      formData.append("Files", file);
    });
    formData.append("Planned", planned);
    formData.append("Attend", attend);

    if (isEdit) {
      formData.append("Id", selectedAgenda?.data?.id);
      formData.append("ModifierId", user.id);
    } else {
      formData.append("OwnerId", user.id);
    }
    try {
      const action = isEdit
        ? await updateAgendaAPI(formData, token)
        : await addAgendaAPI(formData, token);

      dispatch(action);
      await onSuccess?.();
      setShow(false);
      setTitle("");
      setRecordDate("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 25,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
            >
              <img
                src={"/assets/images/add-calender.png"}
                width={25}
                height={25}
                alt=""
              />
            </div>

            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {!isEdit ? Lang.createNewCalender : Lang.editNewCalender}
              </p>
            </div>
          </div>
        </Modal.Title>

        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => setShow(false)}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-12 mb-3">
              <label className="form-label">عنوان</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="ادخل عنوان الأجندة"
              />
              {errors.title && (
                <div className="invalid-feedback d-block">{errors.title}</div>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">نوع الفعالية</label>

              <Select
                value={[
                  { value: true, label: "مخطط" },
                  { value: false, label: "غير مخطط" },
                ].find((x) => x.value === planned)}
                options={[
                  { value: true, label: "مخطط" },
                  { value: false, label: "غير مخطط" },
                ]}
                onChange={(option) => setPlanned(option?.value)}
                placeholder="اختر نوع الفعالية"
              />
            </div>{" "}
            <div className="col-md-4 mb-3">
              <label className="form-label">نوع الحضور</label>

              <Select
                value={[
                  { value: true, label: "فعلي" },
                  { value: false, label: "افتراضى" },
                ].find((x) => x.value === attend)}
                options={[
                  { value: true, label: "فعلي" },
                  { value: false, label: "افتراضى" },
                ]}
                onChange={(option) => setAttend(option?.value)}
                placeholder="اختر نوع الحضور"
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label"> المحاور </label>
              <Select
                value={communitiesList.find((x) => x.value === communityId)}
                options={communitiesList}
                placeholder="المحاور"
                onChange={(option) => {
                  setCommunityId(option?.value || 0);
                }}
              />
              {errors.communityId && (
                <div className="invalid-feedback d-block">
                  {errors.communityId}
                </div>
              )}
            </div>
            <MembersList
              containerStyle="d-flex flex-column mb-4 col-12"
              aboveTitleStyle={`d-flex  col-12 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={"الوزارات/الجهات المعنية بالتكليف"}
              cardStyle={`d-flex flex-column col-12  py-2 ${customStyle(
                "TitleCard",
              )}`}
              cardTitle={Lang.adminMembers}
              list={membersList}
              id={"A"}
              checked={true}
              values={agendaMembers}
              onChange={(e) => {
                const memberId = Number(e.target.value);

                setAgendaMembers((prev) => {
                  if (e.target.checked) {
                    return [...prev, memberId];
                  } else {
                    return prev.filter((id) => id !== memberId);
                  }
                });
              }}
              listError={errors.agendaMembers}
            />
            <div className="col-md-6 mb-3">
              <label className="form-label">تاريخ السجل</label>
              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={recordDate}
                onChange={setRecordDate}
                iconSize={22}
              />{" "}
              {errors.recordDate && (
                <div className="invalid-feedback d-block">
                  {errors.recordDate}
                </div>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">تاريخ النهاية</label>
              <DateInput
                inputStyle={"upperZIndex"}
                placeholder={Lang.form}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                iconPrefix="far"
                iconName="calendar"
                value={endDate}
                onChange={setEndDate}
                iconSize={22}
              />{" "}
              {errors.endDate && (
                <div className="invalid-feedback d-block">{errors.endDate}</div>
              )}
            </div>
            <div className="col-md-12 mb-3">
              <label className="form-label">الملفات المرفقة</label>

              <input
                type="file"
                className="form-control"
                multiple
                onChange={handleFilesChange}
              />

              {isEdit && selectedAgenda?.data?.attachment && (
                <div className="mt-2">
                  <a
                    href={`${paths.Agenda}${selectedAgenda.data.id}/${selectedAgenda.data.attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    {selectedAgenda.data.attachment}
                  </a>
                </div>
              )}

              {errors.file && (
                <div className="invalid-feedback d-block">{errors.file}</div>
              )}
            </div>
          </div>

          <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
            <Button
              type={"submit"}
              disable={isSubmitting}
              buttonStyleType={"solid"}
              content={isSubmitting ? Lang.isSaving : Lang.save}
              containerStyle="col-2 mx-3"
            />
            <Button
              type={"button"}
              onClick={() => setShow(false)}
              content={Lang.cancel}
              containerStyle="col-2 mx-3"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AgendaForm;
